import React, { Component } from 'react';
import Dotdotdot from 'react-dotdotdot';

export default class InboxCard extends Component {
    render() {
        return (
            <div>
                <div className={"inbox-card " + this.props.type}>
                    <div className="inbox-sender">
                        <label>John Doe</label>
                        <span>4783920</span>
                    </div>
                    <div className="inbox-icon">
                        <i className="mdi mdi-share" />
                    </div>
                    <div className="inbox-text">
                        <Dotdotdot clamp={2}>
                            It is a long established fact that a reader will be distracted by the
                        readable content of a page when looking at its layout.
                        </Dotdotdot>
                    </div>
                    <div className="inbox-right">
                        <div className="inbox-time">
                            <span>Jan 30, 2017</span>
                            <span> 11:30 PM </span>
                        </div>
                        <div className="inbox-unread-icon" />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Inbox/InboxCard.jsx